module.exports = __webpack_public_path__ + "static/warehouse-0a7822a91c1caa993ccf630de08b2be0.jpg";